module.exports = __webpack_public_path__ + "static/media/EFR-bg.7f454791.jpg";